import React, { useRef, useEffect } from 'react';
import { Redirect, BrowserRouter, Route, Switch } from 'react-router-dom';
//import { Redirect, Router, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import loadable from '@loadable/component';
import IntroCSS from 'shared/view/IntroCSS';
import RouteChangeTracker from 'common/RouteChangeTracker';
import createHistory from 'history/createBrowserHistory'
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-KGSSXDG'
}

TagManager.initialize(tagManagerArgs);

const CustomerCSS = React.lazy(() => import('shared/view/CustomerCSS'));

// intro
const IntroContainer = loadable(() => import('intro/container/IntroContainer'));
const IConsultationContainer = loadable(() => import('intro/container/IConsultationContainer'));
const INoticeListContainer = loadable(() => import('intro/container/INoticeListContainer'));
const INoticeDetailContainer = loadable(() => import('intro/container/INoticeDetailContainer'));
const IProposalContainer = loadable(() => import('intro/container/IProposalContainer'));
// 서비스 이용약관
const TermsOfServiceContainer = loadable(() => import('intro/container/TermsOfServiceContainer'));
// 개인정보 처리방침
const PrivacyPolicyContainer = loadable(() => import('intro/container/PrivacyPolicyContainer'));

// // QnA 목록
const IFaqListContainer = loadable(() => import('intro/container/IFaqListContainer'));
const ServiceUsageFeeContainer = loadable(() => import('intro/container/ServiceUsageFeeContainer'));
const ServiceOverviewContainer = loadable(() => import('intro/container/ServiceOverviewContainer'));
const SignUpContainer = loadable(() => import('intro/container/SignUpContainer'));
const SignComplContainer = loadable(() => import('intro/container/SignComplContainer'));
const susepayPop = loadable(() => import('intro/view/susepayPop'));

const UsageStatusContainer = loadable(() => import('service/container/UsageStatusContainer'));
const ServiceApplyContainer = loadable(() => import('service/container/ServiceApplyContainer'));
const ServiceDetailContainer = loadable(() => import('service/container/ServiceDetailContainer'));
const ProcessingStatusListContainer = loadable(() => import('service/container/ProcessingStatusListContainer'));
const ProcessingStatusDetailContainer = loadable(() => import('service/container/ProcessingStatusDetailContainer'));
const ReceiveGroupListContainer = loadable(() => import('service/container/ReceiveGroupListContainer'));
const ReceiveGroupRegContainer = loadable(() => import('service/container/ReceiveGroupRegContainer'));
const ReceiveGroupModContainer = loadable(() => import('service/container/ReceiveGroupModContainer'));
const ReceiveGroupDetailContainer = loadable(() => import('service/container/ReceiveGroupDetailContainer'));
const ReceiveListContainer = loadable(() => import('service/container/ReceiveListContainer'));
const ReceiveRegContainer = loadable(() => import('service/container/ReceiveRegContainer'));
const ReceiveDetailContainer = loadable(() => import('service/container/ReceiveDetailContainer'));
const ReceiveModContainer = loadable(() => import('service/container/ReceiveModContainer'));

const DocumentListContainer = loadable(() => import('documentManagement/container/DocumentListContainer'));
const DocumentDetailContainer = loadable(() => import('documentManagement/container/DocumentDetailContainer'));

const DocumentListContainer3pl = loadable(() => import('documentManagement3pl/container/DocumentListContainer'));
const DocumentDetailContainer3pl = loadable(() => import('documentManagement3pl/container/DocumentDetailContainer'));

const RegisterManageViewContainer = loadable(() => import('src/system/container/RegisterManageViewContainer'));
const RegisterManageRegisterContainer = loadable(() => import('src/system/container/RegisterManageRegisterContainer'));
const RegisterManageEditContainer = loadable(() => import('src/system/container/RegisterManageEditContainer'));
const RegisterManageDetailContainer = loadable(() => import('src/system/container/RegisterManageDetailContainer'));
const UserManageListContainer = loadable(() => import('src/system/container/UserManageListContainer'));
const UserManageDetailContainer = loadable(() => import('src/system/container/UserManageDetailContainer'));
const UserManageModifyContainer = loadable(() => import('src/system/container/UserManageModifyContainer'));

const GroupMngtListContainer = loadable(() => import('src/system/container/GroupMngtListContainer'));
const GroupMngtDetailContainer = loadable(() => import('src/system/container/GroupMngtDetailContainer'));
const GroupMngtRegContainer = loadable(() => import('src/system/container/GroupMngtRegContainer'));
const GroupMngtModContainer = loadable(() => import('src/system/container/GroupMngtModContainer'));

const SystemStatusContainer = loadable(() => import('system/container/SystemStatusContainer'));
const SystemStatusDetailContainer = loadable(() => import('system/container/SystemStatusDetailContainer'));
const ProductCodeListContainer = loadable(() => import('system/container/ProductCodeListContainer'));
const ProductCodeRegisterContainer = loadable(() => import('system/container/ProductCodeRegisterContainer'));
const ProductCodeDetailContainer = loadable(() => import('system/container/ProductCodeDetailContainer'));
const ProductCodeModifyContainer = loadable(() => import('system/container/ProductCodeModifyContainer'));

const LoginContainer = loadable(() => import('intro/container/LoginContainer'));
const NewPolicyContainer = loadable(() => import('intro/container/NewPolicyContainer'));
const ChangeStatusContainer = loadable(() => import('intro/container/ChangeStatusContainer'));
const NewPwdContainer = loadable(() => import('intro/container/NewPwdContainer'));
const ChgNewPwdContainer = loadable(() => import('intro/container/ChgNewPwdContainer'));
const LoginConfirmContainer = loadable(() => import('intro/container/LoginConfirmContainer'));

// 대시보드
const DashboardContainer = loadable(() => import('dashboard/container/DashboardContainer'));

// WEB-EDI
const webEdiContainer = loadable(() => import('webEdi/container/webEdiContainer'));

//cs
const NoticeListContainer = loadable(() => import('cs/container/NoticeListContainer'));
const NoticeDetailContainer = loadable(() => import('cs/container/NoticeDetailContainer'));
const FaqListContainer = loadable(() => import('cs/container/FaqListContainer'));
const FaqDetailContainer = loadable(() => import('cs/container/FaqDetailContainer'));
const ArchivesListContainer = loadable(() => import('cs/container/ArchivesListContainer'));
const InquireListContainer = loadable(() => import('cs/container/InquireListContainer'));
const InquireViewContainer = loadable(() => import('cs/container/InquireViewContainer'));
const InquireRegisterContainer = loadable(() => import('cs/container/InquireRegisterContainer'));
const InquireModifyContainer = loadable(() => import('cs/container/InquireModifyContainer'));
const MypageUserInfoContainer = loadable(() => import('cs/container/MypageUserInfoContainer'));
const MypageUserInfoModContainer = loadable(() => import('cs/container/MypageUserInfoModContainer'));
const MypageUserInfoDelContainer = loadable(() => import('cs/container/MypageUserInfoDelContainer'));
const MypageCorpInfoContainer = loadable(() => import('cs/container/MypageCorpInfoContainer'));
const MypageCorpInfoModContainer = loadable(() => import('cs/container/MypageCorpInfoModContainer'));
const MypageCorpInfoDelContainer = loadable(() => import('cs/container/MypageCorpInfoDelContainer'));
const MypageSvcRptInfoContainer = loadable(() => import('cs/container/MypageSvcRptInfoContainer'));
const MypageSvcRptInfoModContainer = loadable(() => import('cs/container/MypageSvcRptInfoModContainer'));
const MypageSvcRptHistListContainer = loadable(() => import('cs/container/MypageSvcRptHistListContainer'));

const CommonViewContainer = loadable(() => import('service/container/CommonViewContainer'));
const ServiceFeePopupContainer = loadable(() => import('service/container/ServiceFeePopupContainer'));
const RedirectPopup = loadable(() => import('shared/view/RedirectPopup'));

const ManuContainer = loadable(() => import('src/manu/container/ManuContainer'));
const ManuRegContainer = loadable(() => import('src/manu/container/ManuRegContainer'));
const ManuDetailContainer = loadable(() => import('src/manu/container/ManuDetailContainer'));




// ErrorPage
const ErrorPage = loadable(() => import('shared/view/ErrorPage'));

const RouteContainer = () => {
	const history = createHistory()
	 history.listen(location => {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    });
    useEffect(() => {
         ReactGA.pageview(window.location.pathname + window.location.search)
     }, [history])
  //
  const useCSS = useRef('IntroCSS');

  const pathArr = ['login', 'dashboard', 'documentManagement', 'service', 'system', 'cs', 'error', 'customer', 'documentManagement3pl'];

  if (window.location.pathname.indexOf('/') > -1) {
    // 경로 있음
    const currentPath = window.location.pathname.split('/');
    const name = currentPath[1];

    if (pathArr.filter((path) => path === name).length > 0) {
      useCSS.current = 'CustomerCSS';
    } else {
      useCSS.current = 'IntroCSS';
    }
    // 루트로 접근 시 intro css load
    if (name === '') {
      useCSS.current = 'IntroCSS';
    }
  }

  return (
    <BrowserRouter>
      {useCSS.current === 'CustomerCSS' && <CustomerCSS />}
      <Switch>
        {/* 인트로 */}
        <Route exact path="/" render={() => <Redirect to="/intro" />}></Route>
        <Route exact path="/intro" component={IntroContainer} />
        {/* 상담신청 */}
        <Route exact path="/intro/consult" component={IConsultationContainer} />
        {/* 서비스 제휴제안 */}
        <Route exact path="/intro/proposal" component={IProposalContainer} />
        {/* 공지사항 목록 */}
        <Route exact path="/intro/noticeList" component={INoticeListContainer} />
        {/* 공지상항 상세 */}
        <Route path="/intro/noticeDetail" component={INoticeDetailContainer} />
        {/* QnA 목록 */}
        <Route path="/intro/faqList" component={IFaqListContainer} />
        {/* 서비스 이용약관 */}
        <Route path="/intro/termsOfService" component={TermsOfServiceContainer} />
        {/* 개인정보 처리방침 */}
        <Route path="/intro/privacyPolicy" component={PrivacyPolicyContainer} />
        <Route path="/intro/service/fee" component={ServiceUsageFeeContainer} />
        <Route path="/intro/service/overview" component={ServiceOverviewContainer} />
        {/* 회원가입 */}
        <Route path="/sign/completed" component={SignComplContainer} />
        <Route path="/sign" component={SignUpContainer} />
        <Route path="/susepayPop" component={susepayPop} />
        {/* 로그인 */}
        <Route path="/login/change/status" component={ChangeStatusContainer} />
        <Route path="/login/newpwd" component={NewPwdContainer} />
        <Route path="/login/chgnewpwd" component={ChgNewPwdContainer} />
        <Route path="/login/newpolicy" component={NewPolicyContainer} />
        <Route path="/login/confirmid" component={LoginConfirmContainer} />

        <Route exact path="/login" component={LoginContainer} />
        {/* 대시보드  */}
        <Route path="/dashboard" component={DashboardContainer} />

        {/* WEB-EDI  */}
        <Route path="/webEdi" component={webEdiContainer} />

        {/* 문서관리 */}
        <Route path="/documentManagement/list" component={DocumentListContainer} />
        <Route path="/documentManagement/detail" component={DocumentDetailContainer} />

        {/* 문서관리(3PL) */}
        <Route path="/documentManagement3pl/list" component={DocumentListContainer3pl} />
        <Route path="/documentManagement3pl/detail" component={DocumentDetailContainer3pl} />

        {/* 시스템관리 */}
        <Route path="/system/registerManage/view" component={RegisterManageViewContainer} />
        <Route path="/system/registerManage/detail" component={RegisterManageDetailContainer} />
        <Route path="/system/registerManage/register" component={RegisterManageRegisterContainer} />
        <Route path="/system/registerManage/edit" component={RegisterManageEditContainer} />
        <Route path="/system/userManage/list" component={UserManageListContainer} />
        <Route path="/system/userManage/detail" component={UserManageDetailContainer} />
        <Route path="/system/userManage/modify" component={UserManageModifyContainer} />
        <Route path="/system/group/list" component={GroupMngtListContainer} />
        <Route path="/system/group/detail" component={GroupMngtDetailContainer} />
        <Route path="/system/group/reg" component={GroupMngtRegContainer} />
        <Route path="/system/group/mod" component={GroupMngtModContainer} />
        {/* 서비스관리 */}
        <Route path="/service/usage/list" component={UsageStatusContainer} />
        <Route path="/service/apply/register" component={ServiceApplyContainer} />
        <Route path="/service/processing/register" component={ServiceApplyContainer} />
        <Route path="/service/apply/detail/:seq" component={ServiceDetailContainer} />
        <Route path="/service/processing/list" component={ProcessingStatusListContainer} />
        <Route path="/service/processing/detail/:seq" component={ProcessingStatusDetailContainer} />
        <Route path="/service/receiveGroup/list" component={ReceiveGroupListContainer} />
        <Route path="/service/receiveGroup/register" component={ReceiveGroupRegContainer} />
        <Route path="/service/receiveGroup/modify/:grpSeq" component={ReceiveGroupModContainer} />
        <Route path="/service/receiveGroup/detail/:grpSeq" component={ReceiveGroupDetailContainer} />
        {/* 제조사 계약 관리 */}
        <Route exact path="/customer/manu/list" component={ManuContainer} />
        <Route exact path="/customer/manu/register" component={ManuRegContainer} />
        <Route exact path="/customer/manu/detail" component={ManuDetailContainer} />
        {/* 알림관리(수신자) */}
        <Route path="/service/receive/list" component={ReceiveListContainer} />
        <Route path="/service/receive/register" component={ReceiveRegContainer} />
        <Route path="/service/receive/modify/:grpSeq" component={ReceiveModContainer} />
        <Route path="/service/receive/detail/:grpSeq" component={ReceiveDetailContainer} />
        {/* 시스템 처리현황 : 장애/오류 목록 조회 및 상세 조회*/}
        <Route path="/system/status/list" component={SystemStatusContainer} />
        <Route path="/system/status/detail" component={SystemStatusDetailContainer} />
        {/* 상품코드 관리 */}
        <Route path="/system/productCode/list" component={ProductCodeListContainer} />
        <Route path="/system/productCode/register" component={ProductCodeRegisterContainer} />
        <Route path="/system/productCode/detail/:seq" component={ProductCodeDetailContainer} />
        <Route path="/system/productCode/modify/:seq" component={ProductCodeModifyContainer} />
        {/* 고객센터 */}
        <Route path="/cs/notice/list" component={NoticeListContainer} />
        <Route path="/cs/notice/detail" component={NoticeDetailContainer} />
        <Route path="/cs/faq/list" component={FaqListContainer} />
        <Route path="/cs/faq/detail/:faqSeq" component={FaqDetailContainer} />
        <Route path="/cs/archives/list" component={ArchivesListContainer} />
        <Route path="/cs/inquire/list" component={InquireListContainer} />
        <Route path="/cs/inquire/view/:inqrySeq" component={InquireViewContainer} />
        <Route path="/cs/inquire/register" component={InquireRegisterContainer} />
        <Route path="/cs/inquire/modify/:inqrySeq" component={InquireModifyContainer} />
        {/* 마이페이지 개인정보*/}
        <Route path="/cs/mypage/user/mod" component={MypageUserInfoModContainer} />
        <Route path="/cs/mypage/user/del" component={MypageUserInfoDelContainer} />
        <Route path="/cs/mypage/user" component={MypageUserInfoContainer} />
        {/* 마이페이지 사업자정보*/}
        <Route path="/cs/mypage/corp/mod" component={MypageCorpInfoModContainer} />
        <Route path="/cs/mypage/corp/del" component={MypageCorpInfoDelContainer} />
        <Route path="/cs/mypage/corp" component={MypageCorpInfoContainer} />
        {/* 마이페이지 요금제관리*/}
        <Route path="/cs/mypage/rpt/mod" component={MypageSvcRptInfoModContainer} />
        <Route path="/cs/mypage/rpt" component={MypageSvcRptInfoContainer} />
        <Route path="/cs/mypage/rpthis" component={MypageSvcRptHistListContainer} />
        {/* 업무와 처리정보 팝업 */}
        <Route exact path="/service/common/view" component={CommonViewContainer} />
        <Route exact path="/service/fee/view" component={ServiceFeePopupContainer} />
        {/* 에러 */}
        <Route exact path="/error" component={RedirectPopup} />
        <Redirect path="*" to="/error" />
        {/* <Route exact component={IntroContainer} /> */}
      </Switch>
    </BrowserRouter>
  );
};

export default RouteContainer;
